import { createAction } from 'redux-actions';
export var SET_EXCHANGE_TYPE = 'SET_EXCHANGE_TYPE';
export var ExchangeType;
(function (ExchangeType) {
    ExchangeType[ExchangeType["Manual"] = 0] = "Manual";
    ExchangeType[ExchangeType["Auto"] = 1] = "Auto";
})(ExchangeType || (ExchangeType = {}));
export var setExchangeType = createAction(SET_EXCHANGE_TYPE, function (type) { return type; });
